import { Button, Grid, Input, Loading, Spinner, Text } from "@nextui-org/react";
import { motion } from "framer-motion";
import { useEffect, useMemo, useState } from "react";
import { TbArrowBackUp, TbRefresh } from "react-icons/tb";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import HistoryTable from "./list";

const Product = () => {
  const token = useSelector((state) => state.invtry.token);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [dbFilter, setDbFilter] = useState("main");

  const loadHandler = (targetFilter = dbFilter) => {
    setLoading(true);
    setError(false);
    const query =
      targetFilter === "alt"
        ? "?alt=true"
        : targetFilter === "sunil"
          ? "?sunil=true"
          : targetFilter === "threeH"
            ? "?threeH=true"
            : "";
    fetch(`https://stockmanager-api.vercel.app/get-products${query}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        console.log(d);
        setData(d.items);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        return setLoading(false);
      });
  };

  useEffect(() => {
    loadHandler(dbFilter);
  }, [dbFilter]);

  return (
    <>
      <motion.div className="header">
        <Link to="/analytics" className="headerLink">
          <TbArrowBackUp className="icoAdjust" />
        </Link>
        <div
          className="selectCustom"
          style={{
            padding: "4px 10px",
            borderRadius: "10px",
            width: "120px",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <select
            id="select"
            value={dbFilter}
            onChange={(event) => setDbFilter(event.target.value)}
            aria-label="Select List"
            style={{ border: "none", width: "100%", background: "transparent" }}
          >
            <option value="main">Main List</option>
            <option value="alt">Alt</option>
            <option value="sunil">Sunil</option>
            <option value="threeH">3H</option>
          </select>
        </div>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Button
            auto
            size={"sm"}
            disabled={loading}
            onClick={() => loadHandler(dbFilter)}
            icon={
              loading ? (
                <Loading type="spinner" color={"error"} />
              ) : (
                <TbRefresh />
              )
            }
          />
        </div>
      </motion.div>
      <motion.div className="qtyContainer alignDivCenter">
        <HistoryTable
          list={data}
          load={() => loadHandler(dbFilter)}
          dbFilter={dbFilter}
        />
      </motion.div>
    </>
  );
};

export default Product;
